<app-table-documents
  *ngIf="operation$ | async as operation"
  [source$]="documents$"
  (add)="onAdd($event, operation)"
  (delete)="onDelete($event, operation)"
></app-table-documents>
